/**
 * Shared helpers for public/homepage event display.
 */

export const PUBLIC_VISIBLE_STATUSES = new Set(['active', 'upcoming', 'finished', 'others']);

export const parsePublicEventDate = (isoStr) => {
  if (isoStr == null || isoStr === '') return null;
  const d = new Date(isoStr);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const getEventStatus = (ev) => (ev?.status || 'active').toLowerCase();

export const isPublicVisibleEvent = (ev) => {
  const status = getEventStatus(ev);
  if (PUBLIC_VISIBLE_STATUSES.has(status)) return true;
  return status !== 'draft' && status !== 'cancelled';
};

export const shouldShowOnHomepage = (ev, eventDate, today) => {
  if (!isPublicVisibleEvent(ev)) return false;
  const status = getEventStatus(ev);
  if (status === 'upcoming' || status === 'finished' || status === 'others') return true;
  if (!eventDate) return true;
  return eventDate >= today;
};

export const sortHomepageEvents = (items) => {
  const statusRank = { upcoming: 0, active: 1, others: 2, finished: 3 };
  return [...items].sort((a, b) => {
    const orderA = a.ev.displayOrder != null && a.ev.displayOrder !== ''
      ? Number(a.ev.displayOrder)
      : Number.MAX_SAFE_INTEGER;
    const orderB = b.ev.displayOrder != null && b.ev.displayOrder !== ''
      ? Number(b.ev.displayOrder)
      : Number.MAX_SAFE_INTEGER;
    if (orderA !== orderB) return orderA - orderB;

    const rankA = statusRank[getEventStatus(a.ev)] ?? 4;
    const rankB = statusRank[getEventStatus(b.ev)] ?? 4;
    if (rankA !== rankB) return rankA - rankB;

    const dateA = a.d ? a.d.getTime() : 0;
    const dateB = b.d ? b.d.getTime() : 0;
    if (getEventStatus(a.ev) === 'finished' || getEventStatus(b.ev) === 'finished') {
      return dateB - dateA;
    }
    return dateA - dateB;
  });
};

export const formatEventStatusLabel = (status) => {
  const value = (status || 'active').toLowerCase();
  if (value === 'active') return 'Ongoing';
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const formatAdminEventStatusLabel = formatEventStatusLabel;
